import {FC, SVGProps} from 'react';

export const PhonePaymentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
		<path
			d="M2.119 7.808a18.41 18.41 0 0 0 4.984 9.089 18.41 18.41 0 0 0 9.089 4.984 4.452 4.452 0 0 0 5.136-3.049l.513-1.604-4.98-2.49-2.386 2.385a15.118 15.118 0 0 1-4.544-3.055 15.118 15.118 0 0 1-3.055-4.544l2.385-2.385-2.49-4.98-1.604.513A4.452 4.452 0 0 0 2.12 7.808Z"
			fill="currentColor"
		/>
	</svg>
);
